var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 41,
    viewBox: "0 0 38 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 0C8.46815 0 0 8.9803 0 20.0581C0 31.136 8.46815 40.1163 18.9142 40.1163C29.3602 40.1163 37.8284 31.136 37.8284 20.0581C37.8284 8.9803 29.3602 0 18.9142 0ZM22.1732 20.4208C21.9893 22.7547 21.3236 24.9973 20.9928 27.305C20.9458 27.7458 20.8481 28.449 21.0534 28.6737C21.618 29.292 22.2075 30.2191 21.9194 31.3297C21.6538 32.3532 20.6609 33.1787 19.6418 33.1787C17.9956 33.1787 16.7634 31.5278 16.4409 30.0723C16.2118 29.0378 16.225 27.9979 16.3563 26.9536C16.6194 24.8582 17.1649 22.8211 17.4664 20.7357C16.5767 20.5899 15.7819 19.8673 15.5387 18.93C15.191 17.5893 15.9579 16.2871 17.172 15.8793C18.4635 15.4457 20.2177 15.5029 21.1741 16.7079C22.3507 18.1911 22.2221 19.7995 22.1732 20.4208ZM19.1399 13.7972C17.3536 13.7972 15.9057 12.2618 15.9057 10.3674C15.9057 8.4731 17.3537 6.93767 19.1399 6.93767C20.9262 6.93767 22.3741 8.47297 22.3741 10.3674C22.3741 12.2618 20.9262 13.7972 19.1399 13.7972Z",
    fill: "#006E7E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/InfoIcon.0aca0e88be392ac1e3e89ac378781e48.svg";
export { ForwardRef as ReactComponent };